module.exports = "<div class=\"row col-xs-12 padding-bottom-20\">\n  <div class=\"row col-xs-2\">\n    <div class=\"image-div skeleton-parent content-size round-image fill-gray\">\n      <div class=\"skeleton\"></div>\n    </div>\n  </div>\n  <div class=\"row col-xs-10\">\n    <itpx-communication-box [config]=\"{message: 'branded.portal.deliverable.status.invalid', level: 'warn'}\">\n    </itpx-communication-box>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/content-tile-invalid/content-tile-invalid.component.html
// module id = 938
// module chunks = 0